import { GUID_, guids } from '@appShared/guids'

const routes = {
   title: 'Southwestern Family of Companies - Company Stock Plan',
   uri: ''
}

export const environment = {
   production: false,
   baseUri: 'https://localhost:44349',
   contentRootUri: '',
   routes
}
